import { POST_API_CALL, GET_API_CALL, DELETE_API_CALL } from "./services"; // adjust path to your actual axios file
import { ENDPOINTS } from "./endPoints";

export const CommonService = {
  uploadFileAndGetUrl: async (file, folderType, getSrcUrl) => {
    try {
      // 1. Get signed URL (merged here)
      console.log(
        "calling api for upload file and get url :",
        file,
        folderType,
        getSrcUrl,
      );

      const uploadData = await new Promise((resolve, reject) => {
        POST_API_CALL(
          ENDPOINTS.COMMON.GENERATE_UPLOAD_URL,
          { folderType: folderType, files: [file.name] },
          (response) => {
            console.log("response of upload file and get url :", response);
            if (response.isSuccess) {
              resolve(response.data[0]);
            } else {
              reject(new Error("Failed to get upload URL"));
            }
          },
        );
      });

      if (!uploadData?.url || !uploadData?.fields) {
        throw new Error("Invalid upload URL response");
      }

      const { url, fields } = uploadData;

      // 2. Prepare FormData
      const formData = new FormData();

      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.append("file", file);

      // 3. Upload to S3
      await fetch(url, {
        method: "POST",
        body: formData,
        mode: "no-cors",
      });

      // 4. Validate key
      if (!fields.key) {
        throw new Error("Missing file key");
      }

      if (getSrcUrl) {
        const srcData = await new Promise((resolve, reject) => {
          GET_API_CALL(
            ENDPOINTS.COMMON.GET_MEDIA_URL,
            `?key=${fields.key}`,
            (response) => {
              console.log("response in get src url :", response);
              if (response.isSuccess) {
                resolve(response.data);
              } else {
                reject(new Error("Failed to get media URL"));
              }
            },
            true,
          );
        });

        console.log("response of src url :", srcData);

        // return {
        //   url: srcData?.url,
        //   name: file.name,
        //   size: file.size,
        //   key: fields.key,
        // };
        return srcData;
      }

      //   return {
      //     url: `${url}${fields.key}`,
      //     name: file.name,
      //     size: file.size,
      //     key: fields.key,
      //   };
      return `${url}${fields.key}`;
    } catch (error) {
      console.error("S3 Upload Failed:", error);
      throw error;
    }
  },

  deleteS3File: async (fileUrl) => {
    try {
      const url = new URL(fileUrl);
      const key = decodeURIComponent(url.pathname.substring(1));

      const res = await new Promise((resolve, reject) => {
        DELETE_API_CALL(
          `${ENDPOINTS.COMMON.DELETE_FILE}${encodeURIComponent(key)}`,
          (response) => {
            if (response.isSuccess) {
              resolve(response.data);
            } else {
              reject(new Error("Failed to delete S3 file"));
            }
          },
        );
      });

      console.log("delete s3 response :", res);
    } catch (error) {
      console.error("Failed to delete S3 file:", error);
      throw error;
    }
  },

  deleteS3Files: async (fileUrls = []) => {
    const uniqueUrls = [...new Set(fileUrls.filter(Boolean))];

    await Promise.all(
      uniqueUrls.map((fileUrl) =>
        CommonService.deleteS3File(fileUrl).catch((error) => {
          console.error("Failed to delete S3 file:", fileUrl, error);
        }),
      ),
    );
  },
};
